/**
 * Typescript helper to check errors schema
 * @param errors Backend form errors schema: { field: string[]; fieldArray: [{ field: string[] }]; Error: ['non field error'] }
 * @returns boolean: True when it is a valid fieldArray schema
 */
export function isFieldArrayGuard(errors) {
    return Array.isArray(errors) && typeof errors[0] !== 'string';
}
